import clsx from 'helpers/clsx';
import { useAppSelector } from 'hooks/redux';
import { useCollections } from 'hooks/useCollections';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Attention } from 'static/imgs/attention.svg';
import { ReactComponent as ArrowBottom } from 'static/imgs/keyboard_arrow_down.svg';

import classes from '../PopupHandleCollections.module.scss';
import { ITempProps } from '../types';
;

const TemplateOn: React.FC<ITempProps> = ({ onClose }) => {
	const { collections } = useAppSelector(state => state.collections);
	const { createEmptyCollection, setShowCollectionsState } = useCollections();
	const { t } = useTranslation('collections');
	const { productGroups } = useAppSelector(state => state.products);

	const collectionsOn = () => {
		setShowCollectionsState(true);
		if (!collections.length) {
			const collectionName = productGroups.length ? t('defaultName').toLocaleUpperCase() : '';
			const sectionsIds = productGroups.reduce((acc: string[], section) => {
				acc.push(section.id);
				return acc;
			}, []);
			createEmptyCollection(productGroups.length, collectionName, sectionsIds);
		};
		onClose();
	};

	return (
		<div className={classes.root}>
			<div className={classes.ico}><Attention/></div>
			<div className={classes.title}>{t('on.title')}</div>
			<div className={classes.text}>{t('on.text')}</div>
			<div className={classes.structureWrap}>
				<div className={classes.levelsWrap}>
					<div className={classes.structureTitle}>{t('currentStructure')}</div>
					<div className={classes.twoStructWrap}>
						<div className={classes.structurePreview}>
							<div className={classes.arr}><ArrowBottom /></div>
							<span>{t('structure.sections')}</span>
						</div>
					</div>
					<div className={classes.threeStructWrap}>
						<div className={classes.structurePreview}><span>{t('structure.products')}</span></div>
					</div>
				</div>
				<span className={classes.separator}><ArrowBottom /></span>
				<div className={clsx(classes.levelsWrap, classes.nextLevelsWrap)}>
					<div className={classes.structureTitle}>{t('treeLevelStructure')}</div>
					<div className={clsx(classes.structurePreview, classes.structurePreviewCollections)}>
						<div className={classes.arr}><ArrowBottom /></div>
						<span>{t('structure.collections')}</span>
					</div>
					<div className={classes.twoStructWrap}>
						<div className={classes.structurePreview}>
							<div className={classes.arr}><ArrowBottom /></div>
							<span>{t('structure.sections')}</span>
						</div>
					</div>
					<div className={classes.threeStructWrap}>
						<div className={classes.structurePreview}><span>{t('structure.products')}</span></div>
					</div>
				</div>
			</div>
			<div className={classes.buttonsWrap}>
				<button onClick={onClose}>{t('cancel')}</button>
				<button className={classes.changeStructureView} onClick={collectionsOn}>{t('on.save')}</button>
			</div>
		</div>
	);
};

export default TemplateOn;
